function handleErrorMessage(respondedError) {
  const defaultMessage = "Unknown Error!";
  let error = { message: defaultMessage };

  if (typeof respondedError.response.data.error.message === "string") {
    error.message = respondedError.response.data.error.message;
    return error;
  }

  let messages;
  if (respondedError.response.data.error.code === "GEN-WRONG-ARGS") {
    messages = respondedError.response.data.error.message;
  } else if (respondedError.response.data.error.message
      && respondedError.response.data.error.message.error
      && respondedError.response.data.error.message.error.code === 'GEN-WRONG-ARGS') {
    messages = respondedError.response.data.error.message.error.message;
  }
  if (messages) {
    error.message = "";
    for (var key in messages) {
      if (messages.hasOwnProperty(key)) {
        error.message += "<p>" + messages[key] + "</p>";
      }
    }
    return error;
  }

  return error;
}

module.exports = {
  handleErrorMessage
};



// WEBPACK FOOTER //
// ./src/utils/store-handler.js